<template>
  <div>
    <!-- 头部 -->
    <div class="noticeBg">
      <div class="banner"></div>
      <div class="notice">
        <!-- 历史公告切换 -->
        <!-- <van-cell center
                  title="查看历史征集问题线索的公告"
                  style="font-size: 16px; font-weight: bold;">
          <template #right-icon>
            <van-switch v-model="isHistorical"
                        size="24"
                        @change="historicalClick" />
          </template>
        </van-cell> -->
        <!-- tab切换 -->
        <!-- <van-tabs v-model="active"
                  @change="handleTabClick"
                  :class="{hidden: isHistorical == true}"
                  ref="tabs">
          <van-tab title="关于公开征集涉企问题线索的公告">
            <p class="title">
              关于公开征集涉企问题线索的公告
            </p>
            <p>
              为贯彻落实党中央、国务院和省委、省政府有关决策部署，进一步解决企业“急难愁盼”问题，优化营商环境，提振市场信心，推动经济高质量发展，结合“大走访大调研大服务大解题”活动需要，自即日起至6月30日，“浙里督”平台面向社会征集涉企问题线索。主要包括以下几方面：
            </p>
            <p>
              一、制造业领域
            </p>
            <p>
              1.当前企业在加快项目投产、充分释放产能方面，在用地、用能、用工、融资等要素保障和政府有关服务方面，以及参与先进制造业基地打造、承接政府财政专项资金政策方面，遇到的问题、存在的困难和诉求。
            </p>
            <p>
              2.企业在增强产品市场竞争力、开拓国际国内市场、抢订单稳客户方面，对政府及有关部门的意见建议。
            </p>
            <p>3.企业对进一步降低企业经营成本、优化营商环境等方面的意见建议。</p>
            <p>
              二、外贸领域
            </p>
            <p>1.当前企业在拓市场、增订单方面，在稳定传统市场、开拓新兴市场方面，在匹配国际市场热点需求、提升出口产品竞争力方面，在保持产业链供应链稳定畅通方面，以及土地、能耗、用工等生产要素保障方面，遇到的问题、存在的困难和诉求。</p>
            <p>2.企业对信保、信贷、融资、退税等金融财税政策，在提高通关便利化、方便人员出入境等方面，对政府及有关部门的意见建议。</p>
            <p>3.企业对所在地方服务保障外贸企业具体举措方面的意见建议。</p>
            <p>三、政府管理服务领域</p>
            <p>是否存在下列问题：</p>
            <p>1.惠企政策落实不够到位，政策宣传不够全面深入。</p>
            <p>2.重大项目推进过程中不担当不作为，对企业提出的诉求视而不见。</p>
            <p>3.服务意识不强，政策规定能解决的事项不及时解决，造成多头跑、重复跑。</p>
            <p>4.涉企乱收费，利用行政手段干预经济纠纷，中介机构违规收费。</p>
            <p>5.执法部门不依法履行监管职责，重监管、轻服务、以罚代管等问题。</p>
            <p>
              广大群众和市场主体如掌握以上问题线索，可以通过“浙里督”微信、支付宝小程序或“浙里办”APP、省政府门户网站“浙里督”平台的“我要投诉”“我要建议”或手机“随手拍”功能反映问题，提供文字、图片、视频线索。省政府督查室将对收到的问题线索进行汇总整理，督促有关地方和部门核查处理。对企业和群众反映强烈、社会影响恶劣、带有普遍性和典型性的重要问题线索，省政府督查室将组织开展实地核查，经查证属实的，依法依规处理。
            </p>
            <p class="r_txt"
               style="padding-right: 70px;">浙江省人民政府督查室</p>
            <p class="r_txt"
               style="padding-right: 108px;">2023年3月6日</p>
            <div class="decorate decorate_left"></div>
            <div class="decorate decorate_right"></div>
          </van-tab>
          <van-tab title="关于征集“十项重大工程”相关问题线索的公告">
            <p class="title">
              关于征集“十项重大工程”相关问题线索的公告
            </p>
            <p>
              为全面贯彻落实省政府工作报告部署，助推今后五年我省10项事关全局、牵一发而动全身的重大工程（以下简称“十项重大工程”）落地落实，自即日起，“浙里督”平台将面向全省广大群众和市场主体征集“十项重大工程”（即：扩大有效投资“千项万亿”工程、“415X”先进制造业集群培育工程、“315”科技创新体系建设工程、服务业高质量发展“百千万”工程、世界一流强港和交通强省建设工程、县城承载能力提升和深化“千村示范、万村整治”工程、跨乡镇土地综合整治工程、文旅深度融合工程、绿色低碳发展和能源保供稳价工程、公共服务“七优享”工程）相关问题线索，“十项重大工程”有关情况说明详见附件。
            </p>
            <p>
              广大群众和市场主体如掌握以上问题线索，包括照片、视频等资料，可以通过“浙里督”平台反映。对其中有关问题线索，省政府督查室将进行实地督查，并依法依规进行处理。
            </p>
            <p><a href="https://zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web1/site/script/zjservice/resources/kstb/images/%E5%8D%81%E9%A1%B9%E9%87%8D%E5%A4%A7%E5%B7%A5%E7%A8%8B%E2%80%9D%E6%9C%89%E5%85%B3%E6%83%85%E5%86%B5%E8%AF%B4%E6%98%8E.xls"
                 target="_blank"
                 rel="noopener noreferrer">
                附件：“十项重大工程”有关情况说明</a>
            </p>
            <p class="r_txt"
               style="padding-right: 70px">浙江省人民政府督查室</p>
            <p class="r_txt"
               style="padding-right: 108px">2023年3月6日</p>
            <div class="decorate decorate_left"
                 style="left: -10px;"></div>
            <div class="decorate decorate_right"
                 style="right: -10px;"></div>
          </van-tab>
        </van-tabs> -->
        <!-- 历史公告的tab切换 -->
        <!-- <van-tabs v-model="activeHitorical" :class="{hidden: isHistorical == false}" ref="tabs">
          <van-tab title="关于春节期间在全省征集有关问题线索的公告">
            <p class="title">
              关于春节期间在全省征集有关问题线索的公告
            </p>
            <p>
              为进一步贯彻落实习近平总书记关于疫情防控工作的重要指示精神和全省疫情防控工作会议精神，推动实现疫情防控转段过渡平稳、社会大局和谐稳定、经济开门稳开门好开门红开门旺，“浙里督”平台将面向全省广大群众和市场主体征集以下问题线索。具体公告如下：
            </p>
            <p>
              一、征集入口：“浙里办”“浙里督”平台
            </p>
            <p>
              二、征集时间：1月19日至1月27日
            </p>
            <p>
              三、征集问题线索内容
            </p>
            <p>（一）疫情防控转段过渡平稳方面：主要征集各地各单位有无制定具体贯彻措施，有无落实医护人员工作补贴，是否还存在涉疫药品“买药难”问题，养老院、福利院等重点区域人员有无失管、脱管，服务是否到位等问题线索。</p>
            <p>
              （二）社会稳定和安全生产方面：主要征集道路交通、消防安全、建筑施工、社会运行等领域是否存在重大事故隐患和违法行为，各地各单位在推进整治安全生产方面是否存在不作为、慢作为等问题线索。
            </p>
            <p>（三）推动经济开门稳、开门好、开门红、开门旺方面：主要征集各地各单位在保障重大项目不停工、重点企业不停产方面是否落实相应服务举措，比如：协调供应防疫物资力度不够、一次性留工补助发放不到位、驻企服务员乱作为等问题线索。</p>
            <p>广大群众和市场主体如掌握以上问题线索，包括照片、视频等资料，可以通过“浙里督”平台反映。对其中有关问题线索，省政府督查室将进行实地督查，并依法依规进行处理。</p>
            <p class="r_txt"
               style="padding-right: 70px;">浙江省人民政府督查室</p>
            <p class="r_txt"
               style="padding-right: 108px;">2023年1月19日</p>
            <div class="decorate decorate_left" style="left: 30px;"></div>
            <div class="decorate decorate_right" style="right: 30px;"></div>
          </van-tab>
          <van-tab title="“浙里督”公开征集“5+4”助企纾困政策落实情况涉企问题线索">
            <p class="title">
              “浙里督”公开征集“5+4”助企纾困政策落实情况涉企问题线索
            </p>
            <p>
              为贯彻落实党中央、国务院和省委、省政府涉企重大决策部署，切实减轻企业负担，进一步优化营商环境、增加市场活力，根据“5+4”政策包快落地真见效有关工作部署，“浙里督”平台从即日起至7月1日面向社会征集涉企问题线索，主要包括以下几个方面：
            </p>
            <p>
              一是政策执行方面。助企纾困相关政策宣传不够全面深入，企业对惠企政策知晓度低；对国家及省里出台的助企纾困政策没有落实或落实不到位，或出台的政策实施办法与上级部署要求不一致。
            </p>
            <p>
              二是政策兑现方面。在落实助企纾困政策过程中存在同区域同类型企业政策兑现区别对待，兑现程序步骤复杂、政策执行慢、兑现不及时等问题。比如奖补、税费优惠、资金支持、支出减免等政策未按要求兑现；企业审批减环节、减时限、减费用等未按规定执行。
            </p>
            <p>
              三是政策服务方面。负责落实助企纾困政策的相关人员服务态度差、服务效率低，没有为企业解决实际困难。
            </p>
            <p>四是“5+4”助企纾困政策执行中存在的其他问题及相关意见建议。</p>
            <p>
              您可以通过“浙里督”微信、支付宝小程序或“浙里办”APP、省政府门户网站“浙里督”平台的“我要投诉”“我要建议”或手机“随手拍”功能反映问题，提供文字、图片、视频线索。省政府办公厅将对收到的问题线索进行汇总整理，督促有关地方和部门核查处理。对企业和群众反映强烈、社会影响恶劣、带有普遍性和典型性的重要问题线索，省政府督查室将直接派员进行督查，经查证属实的，将依法依规严肃处理。
            </p>
            <p><a href="http://www.zj.gov.cn/art/2022/2/7/art_1229017139_2392199.html"
                 target="_blank"
                 rel="noopener noreferrer">附：1.浙江省人民政府办公厅关于减负强企激发企业发展活力的意见</a></p>
            <p><a href="http://www.zj.gov.cn/art/2022/4/28/art_1229017139_2402514.html"
                 target="_blank"
                 rel="noopener noreferrer">2.浙江省人民政府办公厅关于进一步减负纾困助力中小微企业发展的若干意见
              </a></p>
            <p><a href="http://www.zj.gov.cn/art/2022/4/28/art_1229017139_2402508.html"
                 target="_blank"
                 rel="noopener noreferrer">3.浙江省人民政府办公厅关于扶持个体工商户纾困发展的若干意见</a></p>
            <p><a href="http://kjt.zj.gov.cn/art/2022/1/10/art_1229225203_4857110.html"
                 target="_blank"
                 rel="noopener noreferrer">4.浙江省科学技术厅关于印发《科技惠企政策十条》的通知</a></p>
            <p><a href="https://zld.zjzwfw.gov.cn/jmportal_server/files/yqfk-4.pdf"
                 target="_blank"
                 rel="noopener noreferrer">5.浙江省外贸工作领导小组办公室印发《关于金融助力外贸稳增长的若干意见》的通知</a></p>
            <p class="r_txt"
               style="padding-right: 70px;">浙江省政府督查室</p>
            <p class="r_txt"
               style="padding-right: 70px;">2022年4月1日</p>
            <div class="decorate decorate_left"
                 style="left: -10px;"></div>
            <div class="decorate decorate_right"
                 style="right: -10px;"></div>
          </van-tab>
        </van-tabs> -->

        <!-- 新版文案 -->
        <p class="title">
          关于公开征集涉企问题线索的公告
        </p>
        <p>
          为贯彻落实《中共中央 国务院关于促进民营经济发展壮大的意见》，助推解决一批民营经济发展面临的困难和问题，全面推动营商环境再优化再提升，即日起至9月1日，“浙里督”平台面向社会征集涉企问题线索。主要包括以下方面问题线索：
        </p>
        <p>
          一、市场准入壁垒方面
        </p>
        <p>
          （1）有关地方和单位以备案、注册、年检、认定、认证、指定、要求设立分公司等形式设定或变相设定民营企业准入障碍等方面的问题；
        </p>
        <p>
          （2）有关地方和单位将政务服务事项转为中介服务事项，没有法律法规依据在政务服务前要求企业自行检测、检验、认证、鉴定、公证或提供证明等方面的问题。
        </p>
        <p>
          二、落实公平竞争政策制度方面
        </p>
        <p>（1）有关地方和单位未经公平竞争授予经营者特许经营权，限定经营、购买、使用特定经营者提供的商品和服务等方面的问题；</p>
        <p>（2）有关地方和单位出台含有地方保护、市场分割、指定交易等妨碍统一市场和公平竞争政策方面的问题。</p>
        <p>三、政府诚信履约方面</p>
        <p>有关地方和单位违背政府诚信、不兑现承诺等方面的问题。</p>
        <p>四、拖欠账款常态化预防和清理机制方面</p>
        <p>有关地方和单位以履行内部付款流程，或在合同未作约定情况下以等待竣工验收批复等为由，拒绝或延迟支付中小企业和个体工商户款项等方面存在的问题。</p>
        <p>五、法治保障方面</p>
        <p>（1）有关地方和单位在保护民营企业产权、企业家权益方面存在的问题；</p>
        <p>（2）有关地方和单位涉企乱收费、乱罚款、乱摊派方面的问题。</p>
        <p>六、其他不落实《中共中央 国务院关于促进民营经济发展壮大的意见》的问题。</p>
        <p>七、关于进一步促进民营经济发展壮大的意见建议</p>
        <p>
          广大群众和市场主体如掌握以上问题线索或意见建议，可通过“浙里督”微信、支付宝小程序或“浙里办”APP、省政府门户网站“浙里督”平台的“我要投诉”“我要建议”或手机“随手拍”功能反映问题，提供文字、图片、视频线索。省政府督查室将对收到的问题线索进行汇总整理，督促有关地方和部门核查处理。对企业和群众反映强烈、社会影响恶劣、带有普遍性和典型性的重要问题线索，省政府督查室将组织开展实地核查，经查证属实的，依法依规处理。
        </p>
        <p class="r_txt" style="padding-right: 70px;">浙江省人民政府督查室</p>
        <p class="r_txt" style="padding-right: 108px;">2023年8月2日</p>
        <div class="decorate decorate_left"></div>
        <div class="decorate decorate_right"></div>
      </div>
    </div>
    <!-- 我要留言 -->
    <div class="content" :class="{ hidden: isHistorical == true }">
      <van-form ref="form" @submit="submit">
        <p class="words">我要留言</p>
        <h2 class="hClass">问题归属</h2>
        <div class="phone">
          <img src="../assets/h111.png" class="img-responsive" alt="" />
          手机留言点这里
          <div class="weixin" style="display: none">
            <img src="../assets/code.png" class="img-responsive" alt="" />
          </div>
        </div>

        <!-- <van-cell
          is-link
          title="原因分类"
          @click="show1 = true"
          :value="selectAction"
        />
        <van-action-sheet
          v-model="show1"
          :actions="projectid"
          cancel-text="取消"
          close-on-click-action
          @cancel="onCancel"
          @select="select"
        /> -->

        <!-- <p
        style="
          text-align: left;
          margin-left: 2rem !important;
          font-weight: bold;
        "
      >
        原因分类
      </p>
      <van-checkbox-group v-model="result" style="padding: 0 1rem">
        <van-checkbox
          :name="item.code"
          v-for="item in projectid"
          :key="item.name"
          style="margin-bottom: 0.5rem"
          >{{ item.name }}</van-checkbox
        >
      </van-checkbox-group> -->

        <van-cell is-link @click="showPopup" title="事由所在地" :value="addressAction" />
        <van-popup v-model="show2" position="bottom" :style="{ height: '40%' }">
          <van-area title="" :area-list="areaList" @confirm="onConfirm" @cancel="onCancel" @change="getCity" />
        </van-popup>

        <h2 class="hClass">留言内容</h2>
        <van-cell-group>
          <van-field v-model="title" required :rules="titleRules" label="标题" placeholder="请输入线索征集" />
        </van-cell-group>

        <van-field v-model="message" rows="4" autosize required :rules="contentRules" label="详细内容" type="textarea" placeholder="为利于你的问题得到及时处理，请明确填写相关问题的时间、具体地点、事件过程"
          show-word-limit />

        <h2 class="hClass">个人信息</h2>
        <van-cell-group>
          <van-row>
            <van-col span="20">
              <van-field v-model="name" :rules="nameRules" label="我的姓名" placeholder="请填写姓名" required :disabled="nameDisabled" />
            </van-col>
            <van-col span="4">
              <van-field name="switch" label="是否匿名">
                <template #input>
                  <van-switch v-model="nameChecked" @change="onAnonymous" size="20" />
                </template>
              </van-field>
            </van-col>
          </van-row>
        </van-cell-group>

        <van-cell-group>
          <van-field v-model="phone" label="手机号码" placeholder="请输入手机号码" :rules="telRules" name="phone" required />
        </van-cell-group>

        <!-- 短信验证 -->
        <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button size="small" type="info" native-type="button" :disabled="disabled" :loading="loading" :loading-text="number + ''" @click="getCode">发送验证码</van-button>
          </template>
        </van-field>

        <van-cell-group>
          <van-field v-model="email" label="电子邮箱" placeholder="请输入电子邮箱" />
        </van-cell-group>

        <div class="b">附件</div>
        <van-uploader v-model="fileList" multiple />
        <p class="b">
          <span>*</span>{{ pdfTips }}
        </p>

        <!-- <van-radio-group v-model="radio" direction="horizontal">
          <span style="padding-left: 1rem">是否公开</span>
          <van-radio name="1" shape="square">同意</van-radio>
          <van-radio name="2" shape="square">不同意</van-radio>
        </van-radio-group> -->

        <div class="vantSubmit">
          <van-button block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>

      <!-- 底部 -->
      <ul class="link_list">
        <li>
          <p>
            如反映贪污腐败问题、涉法涉诉问题、违法犯罪问题以及其他不在本平台征集范围内的问题，请依法依规向以下部门反映。
          </p>
        </li>
        <li class="links" style="margin-top: 15px">
          <a href="http://www.zjsjw.gov.cn/shouye/" target="_blank" rel="noopener noreferrer">浙江省监察委员会</a>
          |
          <a href="http://www.zjsfgkw.cn/" target="_blank" rel="noopener noreferrer">浙江省高级人民法院</a>
          |
          <a href="http://www.zjjcy.gov.cn/" target="_blank" rel="noopener noreferrer">浙江省检察院</a>
          |
          <a href="http://gat.zj.gov.cn/" target="_blank" rel="noopener noreferrer">浙江省公安厅</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Toast, Tab, Tabs } from 'vant'
import { ask, shengji, phone, file, saveForm, xinfeng } from '../unit/api'
export default {
  name: 'index',
  data() {
    return {
      active: 0,
      pdfTips: '提供关于征集涉企问题线索的实物证据，例如照片、访谈、文件资料等',
      selectAreaCode: '',
      name: '',
      nameDisabled: false,
      title: '',
      message: '',
      phone: '',
      email: '',
      show1: false,
      result: [],
      projectid: '5+4政策包',
      // selectAction: "房屋存在明显倾斜、变形、裂缝等安全隐患",
      // selectCode: "A001",
      show2: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      addressAction: '',
      codeIdMap: {},
      fileList: [
        // { url: "https://img01.yzcdn.cn/vant/leaf.jpg" },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        // { url: "https://cloud-image", isImage: true },
      ],
      radio: '1',
      // 校验名字
      nameRules: [
        {
          required: true,
          // message: "名字不能为空",
          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /^[\u4e00-\u9fa5]+$/.test(value)
          },
          message: '请输入中文',
          trigger: 'onBlur',
        },
      ],
      // 是否匿名
      nameChecked: false,
      // 校验标题
      titleRules: [
        {
          required: true,
          // message: "标题不能为空",
          trigger: 'onBlur',
        },
      ],
      // 校验详情内容
      contentRules: [
        {
          required: true,
          //  message: "标题不能为空",
          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: (value) => {
            if (value.length <= 20) {
              return false
            }
          },
          message: '字数不能少于20字',
          trigger: 'onBlur',
        },
      ],
      // 校验手机号码
      telRules: [
        {
          required: true,
          // message: "手机号码不能为空",
          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },
          message: '请输入正确格式的手机号码',
          trigger: 'onBlur',
        },
      ],
      sms: '',
      dingshiqi: '',
      number: '',
      loading: false,
      disabled: false,
      ggtype: 0,
      isHistorical: false,
      activeHitorical: 0,
    }
  },
  mounted: function () {
    var province_list = {}
    var city_list = {}
    var county_list = {}
    var id = this.GetQueryString('id')
    if (id) {
      var name = this.getName(id)
      this.selectAction = name
    }

    ask().then((data) => {
      this.accessToken = data.data.accessToken
      console.log(data, '1')
      shengji({
        accessToken: data.data.accessToken,
      }).then((data1) => {
        console.log(data1, '2')
        data1.data.forEach(function (value) {
          province_list[value.values] = value.name
          // 市级
          for (let item in value.children) {
            city_list[value.children[item].values] = value.children[item].name
            for (let countyItem in value.children[item].children) {
              county_list[value.children[item].children[countyItem].values] =
                value.children[item].children[countyItem].name
            }
          }
        })
        this.areaList.province_list = province_list
        this.areaList.city_list = city_list
        this.areaList.county_list = county_list
      })
    })
  },
  methods: {
    ssp() {
      window.open(
        'https://zld.zjzwfw.gov.cn/jmportal_server/dc/index.html#/politicalCreationSpace/ssp'
      )
    },
    // 是否匿名
    onAnonymous(or) {
      console.log($('input').css('color', 'blue'), '1')
      if (or) {
        this.name = '匿名用户'
        this.nameDisabled = true
      } else {
        this.name = ''
        this.nameDisabled = false
      }
    },
    onCancel() {
      this.show2 = false
      Toast('取消')
    },
    select(action, index) {
      this.selectAction = action.name
      this.selectCode = action.code
    },
    showPopup() {
      this.show2 = true
    },
    onConfirm(value, index) {
      this.show2 = false
      var address = ''
      value.forEach((element) => {
        address = address + element.name
      })
      this.addressAction = address
      this.selectAreaCode = value[2]
    },
    getCity: function (picker, values, column) {
      console.log(values, 'values')
      if (typeof values[2] == 'undefined' && values[1]) {
        // shengji({
        // accessToken: this.accessToken,
        // areaId: this.codeIdMap[name[1].code],
        // areaName: "county",
        // }).then((data3) => {
        // console.log(data3, '3333')
        // var county_list = Object.assign({}, this.areaList.county_list)
        // let self = this
        // .forEach(function (value) {
        // county_list[value.areaCode] = value.areaName
        // self.codeIdMap[value.areaCode] = value.areaId
        // })
        // })
      }
    },
    getCode() {
      // 局部表单验证
      this.$refs.form
        .validate('phone')
        .then(() => {
          let phoneParam = { phone: this.phone }
          return phone(phoneParam)
        })
        .then(() => {
          this.$toast.success('验证码获取成功')
          this.number = 120
          this.disabled = true
          this.dingshiqi = setInterval(() => {
            this.loading = true
            this.number--
            if (this.number == 0) {
              this.number = ''
              this.loading = false
              this.disabled = false
              clearInterval(this.dingshiqi)
            }
          }, 1000)
        })
        .catch(() => {
          this.$toast.fail('验证码获取失败')
        })
    },
    submit: function () {
      xinfeng({
        phone: this.phone,
        verCode: this.sms,
      })
        .then((data) => {
          console.log(data,'xinfeng');
          if (this.fileList && this.fileList.length > 0) {
            const data1 = new FormData()
            data1.append('file', this.fileList[0].file)
            data1.append('accessToken', this.accessToken)
            return file(data1)
          } else {
            return Promise.resolve(data)
          }
        })
        .then((data) => {
          if (data.success) {
            let param = {
              // ztfl: this.selectCode,
              // projectid: this.result.join(","),
              projectid: this.projectid,
              name: this.name,
              accessToken: this.accessToken,
              county_id: this.selectAreaCode.code,
              title: this.title,
              content: this.message,
              phone: this.phone,
              email: this.email,
              type: 1,
              advice: 0,
              ly: 22,
              is_public: this.radio,
              fileList: data.data,
              ggtype: this.ggtype
            }
            return saveForm(param)
          } else {
            throw new Error('失败')
          }
        })
        .then((data) => {
          console.log(data,'提交');
          if (data.status == '10200') {
            this.$router.push({
              name: 'HelloWorld',
              query: { cxm: data.data.cxm },
            })
            this.$toast.success('提交成功')
          } else {
            this.$toast.fail(data.msg)
          }
        })
        .catch((data) => {
          this.$toast.fail('错误')
        })
    },
    GetQueryString: function (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg) // 获取url中"?"符后的字符串并正则匹配
      var context = ''
      if (r != null) context = r[2]
      reg = null
      r = null
      return context == null || context == '' || context == 'undefined'
        ? ''
        : context
    },
    // getName: function (id) {
    //   var name = "";
    //   this.projectid.forEach((item) => {
    //     if (item.code == id) {
    //       name = item.name;
    //     }
    //   });
    //   return name;
    // },
    handleTabClick(name, title) {
      if (name == 0) {
        this.pdfTips =
          '提供关于征集涉企问题线索的实物证据，例如照片、访谈、文件资料等'
        this.ggtype = 0
      } else if (name == 1) {
        this.pdfTips =
          '提供关于征集浙江省政府“十项重大工程”问题线索的实物证据，例如照片、访谈、文件资料等'
        this.ggtype = 1
      }
    },
    historicalClick(value, x) {
      this.$refs.tabs.resize()
      console.log(value, this.isHistorical)
    },
  },
}
</script>

<style>
body {
  min-width: 1100px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

input,
input:focus,
textarea,
textarea:focus,
select,
select:focus {
  font-size: 14px !important;
}

.hidden {
  display: none;
}

.noticeBg {
  background: #0f59a4;
  padding-bottom: 2%;
}

.banner {
  height: 392px;
  background: url('../assets/h127.png') no-repeat top center;
}

.historicalNotice {
  width: 400px;
  padding: 0 50px;
  margin-bottom: 30px;
  /* margin-left: 350px; */
}

.notice {
  width: 1100px;
  height: 100%;
  border-radius: 6px;
  background: white;
  /* background: url("../assets/titleBg.png") no-repeat 100% 100%; */
  background-size: 100% 100%;
  margin: 0 auto;
  padding: 1% 6% 2% 6%;
  box-sizing: border-box;
  position: relative;
}

.notice p {
  font-size: 22px;
  color: #0f59a4;
  text-indent: 2em;
  line-height: 1.8;
  margin-top: 40px;
  margin-bottom: 0;
  text-align: justify;
  font-weight: bold;
}

.notice p>a {
  color: #0f59a4;
}

.title {
  text-align: center !important;
  text-indent: initial !important;
  font-size: 36px !important;
  font-weight: 700;
  margin-bottom: 60px !important;
}

.r_txt {
  text-align: right !important;
}

.decorate {
  width: 30px;
  height: 83px;
  background: url('../assets/txtBg.png') no-repeat;
}

.decorate_left {
  position: absolute;
  top: 50px;
  left: 130px;
}

.decorate_right {
  position: absolute;
  top: 50px;
  right: 130px;
  background-position-x: right;
}

.van-tabs--line .van-tabs__wrap span {
  font-size: 18px;
  font-weight: bold;
}

.content {
  background: url('../assets/h119.png');
}

.van-form {
  width: 1100px;
  margin: 0 auto;
  position: relative;
}

.words {
  font-size: 30px;
  font-weight: 600;
  color: #0f59a4;
  margin: 0;
  line-height: 4;
  background: url('../assets/h128.png') no-repeat center center;
}

.hClass {
  color: #0f59a4;
  font-size: 24px;
  font-weight: normal;
  position: relative;
  padding: 25px 0 25px 17px;
  margin: 0;
  text-align: left;
}

.hClass:before {
  content: ' ';
  position: absolute;
  width: 4px;
  height: 22px;
  background-color: #0f59a4;
  top: 31px;
  left: 0;
}

.phone {
  position: absolute;
  right: 20px;
  top: 152px;
  line-height: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 14px;
}

.phone img {
  max-width: 100%;
  height: auto;
  float: left;
  margin-right: 3px;
}

.phone .weixin {
  position: absolute;
  top: 30px;
  right: -25px;
  width: 150px;
  z-index: 2;
}

.phone:hover .weixin {
  display: block !important;
}

.van-nav-bar {
  background: #f5f5f5;
}

.van-cell__title>span {
  float: left;
}

.b {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  text-align: left;
  text-indent: 1rem;
  color: #333;
  float: left;
}

.b span {
  color: red;
}

.van-uploader {
  width: 100%;
  padding-top: 1rem;
  float: left;
  padding-left: 1rem;
}

.van-radio-group--horizontal {
  width: 100%;
  font-size: 14px;
  margin-bottom: 1rem;
}

.van-radio {
  margin-left: 2rem;
}

.van-button--large {
  margin-top: 2rem;
}

.van-button--normal {
  font-size: 18px;
}

.vantSubmit {
  width: 320px;
  margin: 20px auto 0;
}

.link_list {
  width: 1100px;
  padding: 0.5rem;
  box-sizing: border-box;
  margin: 0 auto;
}

.link_list p,
span {
  text-align: left;
}

.links a {
  color: #0081ff;
  line-height: 0.5rem;
}

/* 老年版 */
.old_type .title {
  font-size: 32px !important;
}

.old_type .decorate_left {
  left: 100px;
}

.old_type .decorate_right {
  right: 100px;
}

.old_type .notice p {
  font-size: 26px;
}

.old_type .hClass {
  font-size: 28px;
}

.old_type .van-cell__title>span {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue